import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { LoadScript } from '@react-google-maps/api';
import { useNavigate } from 'react-router-dom';

export default function Bookings() {
  const navigate = useNavigate();
  const [bookings, setBookings] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState('all');
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [showEmployeeModal, setShowEmployeeModal] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [employeeForm, setEmployeeForm] = useState({});
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [viewEmployee, setViewEmployee] = useState(null);
  const [activeTab, setActiveTab] = useState('bookings');
  const [employeeSearch, setEmployeeSearch] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [nearbyEmployees, setNearbyEmployees] = useState([]);
  const [users, setUsers] = useState([]);
  const [userSearch, setUserSearch] = useState('');
  const [feedbacks, setFeedbacks] = useState([]);
  const [feedbackSearch, setFeedbackSearch] = useState('');

  const [quotationModal, setQuotationModal] = useState(null);
  const [quotationForm, setQuotationForm] = useState({
    visit_charge: 0,
    subtotal: 0,
    platform_fee: 0,
    cgst: 0,
    sgst: 0,
    grand_total: 0,
    // status: 'Pending',
    items: []
  });


  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isAdminLoggedIn');
    if (!isLoggedIn) {
      navigate('/'); // redirect to login page
    }
  }, [navigate]);

  useEffect(() => {
    axios.get('https://emmasimba.fixidu.com/api/bookings')
      .then(res => {
        console.log("Fetched Bookings:", res.data);
        setBookings(res.data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching bookings:', err);
        setLoading(false);
      });
  }, []);


  useEffect(() => {
    const subtotal = quotationForm.items.reduce(
      (sum, item) => sum + (item.total || 0),
      0
    );

    const visit_charge = Number(quotationForm.visit_charge || 0);
    const platform_fee = 11; // Base fee
    // const platform_gst = platform_fee * 0.18; // GST on platform fee

    const cgst = parseFloat((platform_fee * 0.09).toFixed(2));
    const sgst = parseFloat((platform_fee * 0.09).toFixed(2));

    const grand_total = parseFloat(
      (subtotal + visit_charge + platform_fee + cgst + sgst).toFixed(2)
    );

    setQuotationForm(prev => ({
      ...prev,
      subtotal,
      visit_charge,
      platform_fee,
      cgst,
      sgst,
      grand_total
    }));
  }, [quotationForm.items, quotationForm.visit_charge]);




  const fetchEmployees = async () => {
    try {
      const res = await axios.get("https://emmasimba.fixidu.com/api/employees");
      setEmployees(res.data);
    } catch (err) {
      console.error("Error fetching employees:", err);
    }
  };



  useEffect(() => {
    fetchEmployees();
  }, []);

  useEffect(() => {
    if (selectedBooking) {
      axios
        .get(`https://emmasimba.fixidu.com/api/bookings/${selectedBooking.id}/nearby-employees`)
        .then(res => {
          setNearbyEmployees(res.data);
        })
        .catch(err => console.error("❌ Error fetching nearby employees:", err));
    }
  }, [selectedBooking]);

  useEffect(() => {
    if (activeTab === 'users') {
      axios.get('https://emmasimba.fixidu.com/api/users')
        .then(res => setUsers(res.data))
        .catch(err => console.error("Error fetching users:", err));
    }
  }, [activeTab]);


  const statusColors = {
    '✅ Completed': { bg: '#d4edda', color: '#155724' },
    '⏳ Active': { bg: '#fff3cd', color: '#856404' },
    '❌ Cancelled': { bg: '#f8d7da', color: '#721c24' },
    '⏲️ Pending': { bg: '#d1ecf1', color: '#0c5460' },
    '⛔ On Hold': { bg: '#ffeeba', color: '#856404' },
  };


  const handleEdit = async (booking) => {
    setSelectedBooking(booking); // current booking
    setEditForm({
      preferredDate: booking.preferredDate,
      preferredTime: booking.preferredTime,
      status: booking.status ?? (booking.job_status === 1 ? '✅ Completed' : '⏳ Active'),
      city: booking.city || '',
      area: booking.area || '',
      employeeId: booking.employeeId || ''
    });

    try {
      const res = await axios.get(`https://emmasimba.fixidu.com/api/bookings/${booking.id}/nearby-employees`);
      setNearbyEmployees(res.data);
    } catch (err) {
      console.error("Error fetching nearby employees:", err);
      setNearbyEmployees([]);
    }
  };




  const handleSave = async () => {
    try {
      if (!editForm.preferredDate || !editForm.preferredTime) {
        alert("Date and time are required.");
        return;
      }

      const formattedDate = new Date(editForm.preferredDate).toISOString().split('T')[0];

      const updatedData = {
        preferredDate: formattedDate,
        preferredTime: editForm.preferredTime,
        status: editForm.status,
        employeeId: editForm.employeeId || null  // If not selected, set to null
      };

      const response = await axios.put(
        `https://emmasimba.fixidu.com/api/bookings/${selectedBooking.id}`,
        updatedData
      );

      console.log("✅ Booking updated response:", response.data);

      const updatedBookings = bookings.map(b =>
        b.id === selectedBooking.id ? { ...b, ...updatedData } : b
      );

      setBookings(updatedBookings);
      setSelectedBooking(null);
      alert("Booking updated successfully.");

    } catch (error) {
      console.error('❌ Error updating booking:', error.response?.data || error.message);
      alert("Failed to update booking.");
    }
  };




  const filteredBookings = bookings.filter(b => {
    if (filterStatus === 'all') return true;
    const status = b.status ?? (b.job_status === 1 ? '✅ Completed' : '⏳ Active');
    return status.toLowerCase() === filterStatus;
  });

  const editEmployee = (emp) => {
    setSelectedEmployee(emp);
    setEmployeeForm({
      name: emp.name,
      city: emp.city,
      area: emp.area,
      serviceType: emp.serviceType,
      verified: emp.verified === 1 || emp.verified === true
    });

    setShowEmployeeModal(true);
  };

  const handleSaveEmployee = async () => {
    try {
      const payload = {
        ...employeeForm,
        verified: employeeForm.verified ? 1 : 0,
      };
      await axios.put(`https://emmasimba.fixidu.com/api/employees/${selectedEmployee.id}`, payload);
      const updatedList = employees.map(emp =>
        emp.id === selectedEmployee.id ? { ...emp, ...payload } : emp
      );
      setEmployees(updatedList);
      setShowEmployeeModal(false);
      setSelectedEmployee(null);
    } catch (err) {
      console.error('Error updating employee:', err);
    }
  };


  const verifyEmployee = async (emp) => {
    try {
      await axios.put(`https://emmasimba.fixidu.com/api/employees/${emp.id}/verify`);
      alert(`${emp.name} verified successfully`);


      const updated = employees.map(e =>
        e.id === emp.id ? { ...e, verified: true } : e
      );
      setEmployees(updated);
    } catch (err) {
      console.error("Verification error:", err);
      alert("Failed to verify employee");
    }
  };


  const showQuotation = (booking) => {
    setQuotationModal(booking);
    setQuotationForm({
      visit_charge: booking.visit_charge || 0,
      subtotal: booking.subtotal || 0,
      platform_fee: booking.platform_fee || 0,
      cgst: booking.cgst || 0,
      sgst: booking.sgst || 0,
      grand_total: booking.grand_total || 0,
      // status: booking.quotation_status || "Pending",
      items: booking.items || []
    });
  };





  const handleSaveQuotation = async () => {
    try {
      await axios.post("https://emmasimba.fixidu.com/api/quotation", {
        booking_id: quotationModal.id,                     // ✅ required
        partner_id: quotationModal.partner_id || 1,        // ✅ fallback if null
        visit_charge: quotationForm.visit_charge,
        // status: quotationForm.status,
        items: quotationForm.items,                        // ✅ correctly named
        subtotal: quotationForm.subtotal,
        platform_fee: quotationForm.platform_fee,
        cgst: quotationForm.cgst,
        sgst: quotationForm.sgst,
        grand_total: quotationForm.grand_total
      });

      alert("Quotation saved successfully.");
      setQuotationModal(null);
    } catch (error) {
      console.error("Failed to save quotation:", error.response?.data || error);
      alert("Save failed.");
    }
  };


  useEffect(() => {
    axios.get('https://emmasimba.fixidu.com/api/feedbacks')  // Adjust to your server
      .then(res => setFeedbacks(res.data))
      .catch(err => console.error('Error fetching feedbacks:', err));
  }, []);





  return (
    <LoadScript googleMapsApiKey="AIzaSyCZTEqBDLcPcBm9Ut2u5hrlRplMtM7u6OA" libraries={['places']}>
      <div style={styles.page}>
        <div style={styles.headerRow}>
          <img src="Black LOGO.png" alt="Fixit India Logo" style={styles.logo} />
          <h1 style={styles.heading}>🛠️ Admin Dashboard</h1>
        </div>

        {/* TAB BUTTONS */}
        <div style={{ display: 'flex', gap: '20px', marginBottom: '30px' }}>
          <button
            onClick={() => setActiveTab('bookings')}
            style={{
              padding: '10px 20px',
              borderRadius: '8px',
              backgroundColor: activeTab === 'bookings' ? '#0d6efd' : '#f8f9fa',
              color: activeTab === 'bookings' ? '#fff' : '#000',
              border: '1px solid #dee2e6',
              cursor: 'pointer'
            }}
          >
            📋 Bookings
          </button>
          <button
            onClick={() => setActiveTab('employees')}
            style={{
              padding: '10px 20px',
              borderRadius: '8px',
              backgroundColor: activeTab === 'employees' ? '#0d6efd' : '#f8f9fa',
              color: activeTab === 'employees' ? '#fff' : '#000',
              border: '1px solid #dee2e6',
              cursor: 'pointer'
            }}
          >
            👷 Employees
          </button>

          <button
            onClick={() => setActiveTab('users')}
            style={{
              padding: '10px 20px',
              borderRadius: '8px',
              backgroundColor: activeTab === 'users' ? '#0d6efd' : '#f8f9fa',
              color: activeTab === 'users' ? '#fff' : '#000',
              border: '1px solid #dee2e6',
              cursor: 'pointer',
              marginRight: '10px'
            }}
          >
            🙋 App Users
          </button>

          <button
            onClick={() => setActiveTab('reviews')}
            style={{
              padding: '10px 20px',
              borderRadius: '8px',
              backgroundColor: activeTab === 'reviews' ? '#0d6efd' : '#f8f9fa',
              color: activeTab === 'reviews' ? '#fff' : '#000',
              border: '1px solid #dee2e6',
              cursor: 'pointer'
            }}
          >
            📝 Feedbacks
          </button>
        </div>



        {activeTab === 'bookings' && (
          <div style={styles.card}>
            

            <h2 style={styles.cardTitle}>📋 Service Bookings</h2>

            <div style={styles.filterRow}>
              <label>Filter by Status: </label>
              <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)} style={styles.select}>
                <option value="all">All</option>
                <option value="⏳ active">⏳ Active</option>
                <option value="✅ completed">✅ Completed</option>
                <option value="❌ cancelled">❌ Cancelled</option>
                <option value="⏲️ pending">⏲️ Pending</option>
                <option value="⛔ on hold">⛔ On Hold</option>
              </select>
            </div>

            {loading ? (
              <p>Loading...</p>
            ) : filteredBookings.length === 0 ? (
              <p>No bookings found.</p>
            ) : (
              <table style={styles.table}>
                <thead>
                  <tr style={styles.tableHeaderRow}>
                    <th style={thStyle}>Edit</th>
                    <th style={thStyle}>BID</th>
                    <th style={thStyle}>phone</th>
                    <th style={thStyle}>Service</th>
                    <th style={thStyle}>Address</th>
                    <th style={thStyle}>Date</th>
                    <th style={thStyle}>Time</th>
                    <th style={thStyle}>Status</th>
                    {/* <th style={thStyle}>Employee ID</th> */}

                  </tr>
                </thead>
                <tbody>
                  {filteredBookings.map(b => (
                    <tr key={b.id} style={styles.tableRow}>
                      <td style={tdStyle}>
                        <div style={{ display: 'flex', gap: '6px' }}>
                          <button title="Edit" style={styles.iconButton} onClick={() => handleEdit(b)}>✏️</button>
                          <button title="Quotation" style={styles.iconButton} onClick={() => showQuotation(b)}>📄</button>
                        </div>
                      </td>

                      <td style={tdStyle}>{b.id}</td>
                      <td style={tdStyle}>{b.phone}</td>
                      <td style={tdStyle}>{b.serviceName}</td>
                      <td style={tdStyle}>{b.address}</td>
                      <td style={tdStyle}>{b.preferredDate?.split('T')[0]}</td>

                      <td style={tdStyle}>{b.preferredTime}</td>


                      <td style={tdStyle}>
                        {(() => {
                          const status = b.status ?? (b.job_status === 1 ? '✅ Completed' : '⏳ Active');
                          const colors = statusColors[status] || { bg: '#e2e3e5', color: '#383d41' };
                          return (
                            <span style={{
                              padding: '5px 10px',
                              borderRadius: '8px',
                              backgroundColor: colors.bg,
                              color: colors.color,
                              fontWeight: 500
                            }}>
                              {status}
                            </span>
                          );
                        })()}
                      </td>
                      {/* <td style={tdStyle}>{b.employeeId}</td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            {selectedBooking && (
              <div style={styles.modalOverlay}>
                <div style={styles.modalContent}>
                  <h3>Edit Booking #{selectedBooking.id}</h3>

                  <label>Date: </label>
                  <input
                    type="date"
                    value={editForm.preferredDate}
                    onChange={e => setEditForm({ ...editForm, preferredDate: e.target.value })}
                  /><br />

                  <label>Time: </label>
                  <input
                    type="time"
                    value={editForm.preferredTime}
                    onChange={e => setEditForm({ ...editForm, preferredTime: e.target.value })}
                  /><br />

                  <label>Status: </label>
                  <select
                    value={editForm.status}
                    onChange={e => setEditForm({ ...editForm, status: e.target.value })}
                  >

                    <option value="⏳ Active">⏳ Active</option>
                    <option value="✅ Completed">✅ Completed</option>
                    <option value="❌ Cancelled">❌ Cancelled</option>
                    <option value="⏲️ Pending">⏲️ Pending</option>
                    <option value="⛔ On Hold">⛔ On Hold</option>
                  </select><br />

                  {/* Employee dropdown with only verified employees */}
                  <label>Assign Employee:</label>

                  <select
                    value={editForm.employeeId?.toString() || ''}
                    onChange={e => setEditForm({ ...editForm, employeeId: e.target.value })}
                  >
                    <option value="">-- Select Employee --</option>

                    {nearbyEmployees.length === 0 ? (
                      <option value="">No verified employees nearby</option>
                    ) : (
                      nearbyEmployees
                        .filter(emp =>
                          emp.serviceType?.toLowerCase() === selectedBooking.serviceName?.toLowerCase()
                        )
                        .map(emp => (
                          <option key={emp.id} value={emp.id}>
                            {emp.name} - {emp.city} ({emp.serviceType})
                          </option>
                        ))
                    )}
                  </select>
                 {editForm.employeeId && (() => {
  const emp = nearbyEmployees.find(emp => emp.id.toString() === editForm.employeeId?.toString());
  if (!emp) return null;

  return (
    <>
      <p><strong>Assigned QR ID:</strong> {emp.qr_id || 'N/A'}</p>
      {/* <p>
        <a
          href={`https://partnerapp.fixidu.com/employee/${emp.qr_id}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#E23830', textDecoration: 'underline' }}
        >
          View Employee Profile
        </a>
      </p> */}
    </>
  );
})()}


                  <br />

                  <div style={{ marginTop: '20px' }}>
                    <button onClick={handleSave} style={styles.saveBtn}>💾 Save</button>
                    <button onClick={() => setSelectedBooking(null)} style={styles.cancelBtn}>❌ Cancel</button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}


        {activeTab === 'employees' && (
          <div style={styles.card}>
            <h2 style={styles.cardTitle}>👷 Registered Employees</h2>
            <input
              type="text"
              placeholder="Search employee..."
              style={{ marginBottom: '15px', padding: '8px', width: '250px' }}
              value={employeeSearch}
              onChange={e => setEmployeeSearch(e.target.value)}
            />

            <table style={styles.table}>
              <thead>
                <tr style={styles.tableHeaderRow}>
                  <th style={thStyle}>QR ID</th>
                  <th style={thStyle}>Name</th>
                  <th style={thStyle}>City</th>
                  <th style={thStyle}>Area</th>
                  <th style={thStyle}>serviceType</th>
                  <th style={thStyle}>Verified</th>
                  <th style={thStyle}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {employees
                  .filter(emp =>
                    emp.name?.toLowerCase().includes(employeeSearch.toLowerCase()) ||
                    emp.city?.toLowerCase().includes(employeeSearch.toLowerCase()) ||
                    emp.serviceType?.toLowerCase().includes(employeeSearch.toLowerCase())
                  )
                  .map(emp => (

                    <tr key={emp.id} style={styles.tableRow}>
                      <td style={tdStyle}>{emp.qr_id}</td>
                      <td style={tdStyle}>{emp.name}</td>
                      <td style={tdStyle}>{emp.city}</td>
                      <td style={tdStyle}>{emp.area}</td>
                      <td style={tdStyle}>{emp.serviceType}</td>
                      <td style={tdStyle}>{emp.verified ? "✅ Yes" : "❌ No"}</td>
                      <td style={tdStyle}>
                        <div style={styles.dropdown}>
                          <button
                            style={styles.dropdownBtn}
                            onClick={() =>
                              setOpenDropdownId(openDropdownId === emp.id ? null : emp.id)
                            }
                          >
                            ⋮
                          </button>
                          {openDropdownId === emp.id && (
                            <div style={styles.dropdownContent}>
                              <div onClick={() => { editEmployee(emp); setOpenDropdownId(null); }} style={styles.dropdownItem}> ✏️ Edit
                              </div>
                              <div onClick={() => { setViewEmployee(emp); setOpenDropdownId(null); }} style={styles.dropdownItem}> 👁️ View
                              </div>
                              {!emp.verified && (
                                <div onClick={() => { verifyEmployee(emp); setOpenDropdownId(null); }} style={styles.dropdownItem}> ✅ Verify
                                </div>
                              )}

                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>

            {viewEmployee && (
              <div style={styles.modalOverlay}>
                <div style={styles.modalContent}>
                  <h3>Employee Profile - {viewEmployee.name}</h3>
                  <p><b>QR ID:</b> {viewEmployee.qr_id}</p>
                  <p><b>DOB:</b> {viewEmployee.dob}</p>
                  <p><b>State:</b> {viewEmployee.state}</p>
                  <p><b>City:</b> {viewEmployee.city}</p>
                  <p><b>Area:</b> {viewEmployee.area}</p>
                  <p><b>Address:</b> {viewEmployee.full_address}</p>
                  <p><b>serviceType</b> {viewEmployee.serviceType}</p>
                  <p><b>Bank:</b> {viewEmployee.bank_name} ({viewEmployee.branch_name})</p>
                  <p><b>Account:</b> {viewEmployee.account_number} / IFSC: {viewEmployee.ifsc_code}</p>
                  <div style={{ display: 'flex', gap: 10 }}>
                    <img
                      src={`https://partner.fixidu.com/uploads/photo/${viewEmployee.photo}`}
                      width="80"
                      alt="Profile"
                      style={{ cursor: 'pointer' }}
                      onClick={() => setSelectedImage(`https://partner.fixidu.com/uploads/photo/${viewEmployee.photo}`)}
                    />

                    

                
                  </div>
                  <p><b>QR Code:</b></p>
                  <img
                    src={`https://partner.fixidu.com/uploads/qrs/${viewEmployee.qr_file}`}
                    alt="QR Code"
                    width="100"
                    style={{ marginBottom: '10px' }}
                    onClick={() => setSelectedImage(`https://partner.fixidu.com/uploads/qrs/${viewEmployee.qr_file}`)}
                  />


                  <button onClick={() => setViewEmployee(null)} style={styles.cancelBtn}>❌ Close</button>
                </div>
              </div>
            )}

            {selectedImage && (
              <div
                style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  width: '100vw',
                  height: '100vh',
                  backgroundColor: 'rgba(0,0,0,0.7)',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  zIndex: 1000,
                }}
                onClick={() => setSelectedImage(null)}
              >
                <img
                  src={selectedImage}
                  alt="Full View"
                  style={{
                    maxWidth: '90%',
                    maxHeight: '90%',
                    borderRadius: 10,
                    boxShadow: '0 0 20px white',
                  }}
                />
              </div>
            )}


            {showEmployeeModal && selectedEmployee && (
              <div style={styles.modalOverlay}>
                <div style={styles.modalContent}>
                  <h3>Edit Employee - {selectedEmployee.name}</h3>
                  <label>Name:</label>
                  <input type="text" value={employeeForm.name} onChange={e => setEmployeeForm({ ...employeeForm, name: e.target.value })} style={styles.inputBox} />
                  <label>City:</label>
                  <input type="text" value={employeeForm.city} onChange={e => setEmployeeForm({ ...employeeForm, city: e.target.value })} style={styles.inputBox} />
                  <label>Area:</label>
                  <input type="text" value={employeeForm.area} onChange={e => setEmployeeForm({ ...employeeForm, area: e.target.value })} style={styles.inputBox} />
                  <label>serviceType</label>
                  <input type="text" value={employeeForm.serviceType} onChange={e => setEmployeeForm({ ...employeeForm, serviceType: e.target.value })} style={styles.inputBox} />
                  <label style={{ marginTop: '10px' }}>Verified:</label>
                  <input type="checkbox" checked={employeeForm.verified === 1 || employeeForm.verified === true}
                    onChange={e => setEmployeeForm({ ...employeeForm, verified: e.target.checked ? 1 : 0 })}
                    style={{ marginLeft: '10px', transform: 'scale(1.2)' }} />
                  <span style={{ marginLeft: '8px' }}>{employeeForm.verified ? "Yes" : "No"}</span>
                  <div style={{ marginTop: '20px' }}>
                    <button onClick={handleSaveEmployee} style={styles.saveBtn}>💾 Save</button>
                    <button onClick={() => setShowEmployeeModal(false)} style={styles.cancelBtn}>❌ Cancel</button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {activeTab === 'users' && (
          <div style={styles.card}>
            <h2 style={styles.cardTitle}>🙋 Registered App Users</h2>

            <input
              type="text"
              placeholder="Search by name or phone..."
              value={userSearch}
              onChange={e => setUserSearch(e.target.value)}
              style={{ marginBottom: '15px', padding: '8px', width: '250px' }}
            />

            <table style={styles.table}>
              <thead>
                <tr style={styles.tableHeaderRow}>
                  <th style={thStyle}>ID</th>
                  <th style={thStyle}>Name</th>
                  <th style={thStyle}>Email</th>
                  <th style={thStyle}>Phone</th>
                  {/* <th style={thStyle}>Image</th> */}
                  <th style={thStyle}>Registered On</th>
                </tr>
              </thead>
              <tbody>
                {users
                  .filter(user =>
                    user.name?.toLowerCase().includes(userSearch.toLowerCase()) ||
                    user.phone?.includes(userSearch)
                  )
                  .map(user => (
                    <tr key={user.id} style={styles.tableRow}>
                      <td style={tdStyle}>{user.id}</td>
                      <td style={tdStyle}>{user.name}</td>
                      <td style={tdStyle}>{user.email}</td>
                      <td style={tdStyle}>{user.phone}</td>
                      {/* <td style={tdStyle}>
                <img
                  src={`https://192.168.40.135:4000/uploads/${user.profileImage}`}
                  alt="Profile"
                  width="50"
                  style={{ borderRadius: '8px' }}
                />
              </td> */}
                      <td style={tdStyle}>{user.created_at?.split('T')[0]}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}

        {activeTab === 'reviews' && (
          <div>
            <h2>📝 User Feedbacks</h2>

            <input
              type="text"
              placeholder="Search feedbacks..."
              value={feedbackSearch}
              onChange={e => setFeedbackSearch(e.target.value)}
              style={{ marginBottom: '15px', padding: '8px', width: '250px' }}
            />

            <table className="table table-striped">
              <thead>
                <tr style={styles.tableHeaderRow}>
                  <th style={thStyle}>Name</th>
                  <th style={thStyle}>Service</th>
                  <th style={thStyle}>Feedback</th>
                  <th style={thStyle}>Rating</th>
                  <th style={thStyle}>Date</th>
                </tr>
              </thead>
              <tbody>
                {feedbacks
                  .filter(item =>
                    (item.user_name || '').toLowerCase().includes(feedbackSearch.toLowerCase()) ||
                    (item.serviceName || '').toLowerCase().includes(feedbackSearch.toLowerCase())
                  )
                  .map((item, index) => (
                    <tr key={index} style={styles.tableRow}>
                      <td style={tdStyle}>{item.user_name}</td>
                      <td style={tdStyle}>{item.serviceName}</td>
                      <td style={tdStyle}>{item.feedback}</td>
                      <td style={tdStyle}>{item.rating}</td>
                      <td style={tdStyle}>{item.created_at?.split('T')[0]}</td>
                    </tr>
                  ))
                }

              </tbody>
            </table>
          </div>
        )}



        {quotationModal && (
          <div style={styles.modalOverlay}>
            <div style={styles.modalContent}>
              <h2 style={{ marginBottom: 30, fontSize: '24px', color: '#333' }}>
                ✏️ Quotation - Booking #{quotationModal.id}
              </h2>

              {/* Service Items Table */}
              <section style={{ marginBottom: 40 }}>
                <label style={{ fontWeight: '600', fontSize: 17, marginBottom: 10, display: 'inline-block', color: '#222' }}>
                  🛠️ Service Requirements:
                </label>

                {/* Table Header */}
                <div
                  style={{
                    display: 'flex',
                    fontWeight: 600,
                    backgroundColor: '#f7f7f7',
                    border: '1px solid #ccc',
                    borderRadius: 6,
                    padding: '10px',
                    marginBottom: 8,
                    color: '#333'
                  }}
                >
                  <div style={{ flex: 2 }}>Item</div>
                  <div style={{ flex: 1, textAlign: 'right' }}>Rate</div>
                  <div style={{ flex: 1, textAlign: 'right' }}>Qty</div>
                  <div style={{ flex: 1, textAlign: 'right' }}>Total</div>
                  <div style={{ width: 30 }}></div>
                </div>

                {/* Service Item Rows */}
                {quotationForm.items.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      display: 'flex',
                      gap: 10,
                      marginBottom: 10,
                      alignItems: 'center'
                    }}
                  >
                    <input
                      type="text"
                      placeholder="Item Name"
                      value={item.name}
                      onChange={e => {
                        const newItems = [...quotationForm.items];
                        newItems[index].name = e.target.value;
                        setQuotationForm({ ...quotationForm, items: newItems });
                      }}
                      style={{ ...styles.inputBox, flex: 2 }}
                    />

                    <input
                      type="number"
                      placeholder="Rate"
                      value={item.rate || ''}
                      onChange={e => {
                        const newItems = [...quotationForm.items];
                        newItems[index].rate = Number(e.target.value);
                        newItems[index].total = newItems[index].rate * (newItems[index].qty || 0);
                        setQuotationForm({ ...quotationForm, items: newItems });
                      }}
                      style={{ ...styles.inputBox, flex: 1, textAlign: 'right' }}
                    />

                    <input
                      type="number"
                      placeholder="Qty"
                      value={item.qty || ''}
                      onChange={e => {
                        const newItems = [...quotationForm.items];
                        newItems[index].qty = Number(e.target.value);
                        newItems[index].total = (newItems[index].rate || 0) * newItems[index].qty;
                        setQuotationForm({ ...quotationForm, items: newItems });
                      }}
                      style={{ ...styles.inputBox, flex: 1, textAlign: 'right' }}
                    />

                    <input
                      type="text"
                      value={`₹ ${(item.total || 0).toFixed(2)}`}
                      readOnly
                      style={{ ...styles.inputBox, flex: 1, backgroundColor: '#f3f3f3', textAlign: 'right' }}
                    />

                    <button
                      onClick={() => {
                        const newItems = quotationForm.items.filter((_, i) => i !== index);
                        setQuotationForm({ ...quotationForm, items: newItems });
                      }}
                      style={{
                        ...styles.cancelBtn,
                        backgroundColor: '#e74c3c',
                        color: '#fff',
                        padding: '6px 10px',
                        fontSize: 14,
                        borderRadius: 5,
                        cursor: 'pointer'
                      }}
                    >
                      ✕
                    </button>
                  </div>
                ))}

                {/* Add Item Button */}
                <button
                  onClick={() =>
                    setQuotationForm({
                      ...quotationForm,
                      items: [...quotationForm.items, { name: '', rate: 0, qty: 1, total: 0 }]
                    })
                  }
                  style={{
                    marginTop: 12,
                    backgroundColor: '#0d6efd',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 6,
                    padding: '8px 16px',
                    fontSize: 14,
                    cursor: 'pointer'
                  }}
                >
                  ➕ Add Item
                </button>
              </section>


              {/* Charges Summary */}
              <section style={{ borderTop: '1px solid #ddd', paddingTop: 20, marginBottom: 20 }}>
                {[
                  ['Subtotal', quotationForm.subtotal?.toFixed(2) || '0.00', false],
                  ['Visit Charge', quotationForm.visit_charge || 0, true],
                  ['Platform Fee', 11, false],
                  ['CGST (9%)', quotationForm.cgst?.toFixed(2) || '0.00', false],
                  ['SGST (9%)', quotationForm.sgst?.toFixed(2) || '0.00', false]
                ].map(([label, value, editable]) => (
                  <div
                    key={label}
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      gap: '20px',
                      marginBottom: 10,
                      alignItems: 'center'
                    }}
                  >
                    <div style={{ width: '180px', fontWeight: 500 }}>{label}</div>
                    {editable ? (
                      <input
                        type="number"
                        value={value}
                        onChange={e =>
                          setQuotationForm(prev => ({
                            ...prev,
                            visit_charge: Number(e.target.value)
                          }))
                        }
                        style={{ ...styles.inputBox, width: '150px' }}
                      />
                    ) : (
                      <div style={{ width: '150px', backgroundColor: '#f3f3f3', padding: '8px', borderRadius: '5px' }}>
                        ₹ {value}
                      </div>
                    )}
                  </div>
                ))}

                {/* Grand Total */}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: '20px',
                    marginTop: 20,
                    fontWeight: 'bold',
                    fontSize: 18,
                    color: '#111',
                    borderTop: '1px solid #e74c3c',
                    paddingTop: 12
                  }}
                >
                  <div style={{ width: '180px' }}>Grand Total</div>
                  <div style={{ width: '150px', color: '#e74c3c' }}>₹ {quotationForm.grand_total?.toFixed(2) || '0.00'}</div>
                </div>
              </section>

              {/* Quotation Status */}
              {/* <div style={{ marginBottom: '15px' }}>
                <label>Status</label>
                <select
                  value={quotationForm.status}
                  onChange={e => setQuotationForm({ ...quotationForm, status: e.target.value })}
                  style={styles.inputBox}
                >
                  <option value="pending">pending</option>
                  <option value="approved">approved</option>
                  <option value="rejected">rejected</option>
                  <option value="generated">generated</option>
                </select>
              </div> */}

              {/* Save + Cancel */}
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: 20 }}>
                <button onClick={handleSaveQuotation} style={styles.saveBtn}>💾 Save</button>
                <button onClick={() => setQuotationModal(null)} style={styles.cancelBtn}>❌ Cancel</button>
              </div>
              <button
  onClick={() => {
    setQuotationModal(bookings);
    setQuotationForm({
      visit_charge: 0,
      subtotal: 0,
      platform_fee: 11,
      cgst: 0,
      sgst: 0,
      grand_total: 0,
      items: []
    });
  }}
>
  ➕ Add Another Quotation
</button>
            </div>
          </div>
        )}


      </div>
    </LoadScript>
  );
}


const styles = {
  page: {
    fontFamily: 'Segoe UI, sans-serif',
    padding: '40px',
    backgroundColor: '#f8f9fa',
    minHeight: '100vh'
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '10px'
  },
  logo: {
    width: '80px',
    height: '80px'
  },
  heading: {
    margin: 10,
    color: '#212529',
    fontSize: '32px',
    flex: 1,
    textAlign: 'center'
  },
  card: {
    backgroundColor: '#fff',
    padding: '25px',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
  },
  cardTitle: {
    marginBottom: '20px',
    color: '#343a40'
  },
  filterRow: {
    marginBottom: '20px',
    color: '#343a40'
  },
  select: {
    marginLeft: '10px',
    padding: '6px 12px',
    borderRadius: '6px',
    border: '1px solid #ced4da',
    backgroundColor: '#fff'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse'
  },
  tableHeaderRow: {
    backgroundColor: '#f1f3f5'
  },
  tableRow: {
    borderBottom: '1px solid #dee2e6'
  },
  editButton: {
    padding: '4px 8px',
    borderRadius: '4px',
    backgroundColor: '#0d6efd',
    color: '#fff',
    border: 'none',
    cursor: 'pointer'
  },
  inputBox: {
    padding: '8px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    width: '100%',
    fontSize: '14px'
  },
  saveBtn: {
    backgroundColor: '#2E8B57',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    padding: '8px 16px',
    cursor: 'pointer'
  },
  cancelBtn: {
    backgroundColor: '#ccc',
    color: '#000',
    border: 'none',
    borderRadius: '5px',
    padding: '8px 16px',
    cursor: 'pointer'
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.6)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000
  },
  modalContent: {
    backgroundColor: '#fff',
    padding: '30px',
    borderRadius: '12px',
    maxWidth: '600px',
    width: '100%',
    maxHeight: '90vh',
    overflowY: 'auto'
  },
  dropdown: {
    position: 'relative',
    display: 'inline-block'
  },
  dropdownBtn: {
    backgroundColor: '#0d6efd',
    color: 'white',
    padding: '4px 10px',
    fontSize: '14px',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer'
  },
  dropdownContent: {
    position: 'absolute',
    backgroundColor: '#ffffff',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    zIndex: 1,
    minWidth: '140px',
    borderRadius: '8px',
    overflow: 'hidden',
    top: '110%',
    left: '0'
  },
  dropdownItem: {
    padding: '10px',
    cursor: 'pointer',
    borderBottom: '1px solid #f1f1f1',
    color: '#212529',
    backgroundColor: '#fff'
  },
  iconButton: {
    padding: '6px 10px',
    borderRadius: '6px',
    backgroundColor: '#0d6efd',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    fontSize: '16px'
  }
};
const thStyle = {
  padding: '14px 12px',
  textAlign: 'left',
  fontWeight: '600',
  color: '#495057',
  fontSize: '15px',
  borderBottom: '1px solid #dee2e6',
};

const tdStyle = {
  padding: '12px',
  fontSize: '14px',
  color: '#343a40',
};
